module.exports = __webpack_public_path__ + "img/sponsor_footer.4963fd4d.png";